import concat from 'lodash/concat';
/**
 * Given an array of values and a function to create promises from them, run the
 * promises in sequence.
 * */
export async function sequencePromises<T, U>(xs: T[], generator: (plain: T, idx: number) => Promise<U>): Promise<U[]> {
  /**
   * Helper function: rest is the values left to process, and acc accumulates the results.
   * */
  const go = async (rest: T[], acc: U[], idx: number): Promise<U[]> => {
    if (rest.length === 0) return acc;
    const [head, ...tail] = rest;
    const result = await generator(head, idx);
    return go(tail, concat(acc, [result]), idx + 1);
  };
  return go(xs, [], 0);
}
